<template lang="html">
  <div class="has-text-centered">
    <div class="store-links columns">
      <a
        class="column"
        href="https://itunes.apple.com/us/app/rolloff-electronic-dispatch/id1346790537"
        ><img
          src="../../assets/badge-app-store.svg"
          alt="App Store"
          class="store-badge"
      /></a>
      <a
        class="column"
        href="https://play.google.com/store/apps/details?id=com.callcw.redmobile"
        ><img
          src="../../assets/badge-ggl-play.png"
          alt="Get on Google Play"
          class="store-badge"
      /></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-store-buttons',
};
</script>

<style lang="stylus" scoped>

.store-links {
  .store-badge {
    width: 100%
    max-width: 180px
  }
}
</style>
